module.exports = __webpack_public_path__ + "img/fabric.79e39c83.svg";